import { ItemStatus } from '../enums/item.enum';
import { RestaurantAddress } from './restaurant.model';

export class LiveOrders {
  constructor(
    public reserved: CurrentOrder[] = [],
    public prepared: CurrentOrder[] = []
  ) {
  }
}

export class CurrentOrder {
  constructor(
    public id: string = null,
    public source: string = null,
    public number: string = '0000',
    public type: string = null,
    public state: ItemStatus = null,
    public customerName: string = 'Order',
    public pickup: string = null,
    public locationName: string = null,
    public orderDate: string = null
  ) {
  }
}

export class CurrentOrderLocation {
  constructor(
    public name: string = 'Location',
    public phone: string = '1234444444',
    public address: RestaurantAddress =  new RestaurantAddress(),
    public logoUrl: string = null
  ) {
  }
}
